(ns web3.screens.add
  (:require [reagent.core :as r]
            [web3.components.icons :as icons]
            [web3.modals.forms :as forms]
            [web3.components.parent :as parent]
            [web3.components.widgets :as widgets]
            [web3.screens.files :as files]
            [web3.forms.fields :as fields]
            [web3.i18n :as i]
            [web3.persistence.graphql :as g]
            [web3.queries.asset :as q-asset]
            [web3.queries.root :as q-root]
            [web3.routing.core :as routing]
            [web3.utils :as utils]
            [web3.view :as v]
            [web3.forms.validation :as validation]
            [web3.persistence.schema :as schema]
            [re-frame-simple.db :as db]
            [web3.screens.property :as property]
            [web3.constants :as constants]
            [web3.persistence.realtime :as realtime]
            [web3.components.text :as text]
            [web3.components.branch :as branch]
            [web3.hints.core :as hints]
            [web3.persistence.current-property :as current-property]
            [web3.routers.app-helpers :as app-route]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]))

(def MAX-WIDTH 375)

(defn center [props & children]
  (let [[props children] (if (map? props) [props children] [nil (cons props children)])]
    (into [:div.flex.flex-column.margin-h-auto.pad-all-3
           (-> props
               (dissoc :back-href)
               (v/merge-props {:style {:max-width MAX-WIDTH}}))]
          children)))

(def divider-or [:div.margin-top-2.flex.items-center.justify-center
                 [:div.text-uppercase.bg-darken-1.round-100p.text-dark-gray.flex.items-center.justify-around {:style {:width 40 :height 40}} "Or"]])

(defn divider-line [& [props]]
  [:div.bg-light-gray.margin-v-3
   (v/merge-props props
                  {:style {:height 1}})])


;; ========== Add Content ==========

(def picker-item-classes "width-25p content flex-column items-center inline-flex text-black hover-text-real-black")

(v/defview collection-picker
  {:header {:title (i/get :i/add-file)}}
  [{:keys [handler]}]
  (let [anything? (= "add-anything" (namespace handler))]
    [:div.pad-all-3
     (doall
      (for [collection [:files/media
                        :files/receipts
                        :files/documents
                        :files/notes]]
        [:a
         {:key collection
          :class picker-item-classes
          :href (routing/path-for [(if anything?
                                     :add-anything/file.collection
                                     :add/file.collection) :collection (name collection)])}
         (-> (icons/get collection)
             (hiccup/size 30))
         [:div.margin-top-3.text-center.text-size-10.text-uppercase.weight-medium
          (i/get collection)]]))]))

(defn other-picker []
  [:div.margin-v-3
   (doall
    (for [[key props] [[:type/AssetGroup
                        {:href (routing/path-for [:add-anything/group])
                         :icon (-> (icons/get :type/AssetGroup)
                                   (update 1 assoc :id "button-add-group"))}]
                       #_[:type/Reminder {}]
                       [:type/ServiceProvider
                        {:href (routing/path-for [:add-anything/service-provider])}]
                       [:type/Property
                        {:href (routing/path-for [:add-anything/property])}]]]
      [(if (:href props)
         :a :div)
       (v/merge-props props
                      {:key key
                       :class picker-item-classes})
       (-> (or (:icon props) (icons/get key))
           (hiccup/size 30))
       [:div.margin-top-3.text-center.text-size-10.text-uppercase.weight-medium
        (i/get key)]]))])

(v/defview asset-start
  {:header {:title (i/get :i/add-item)}
   :component-did-mount
   #(hints/show! [:hint/add.anything.by-form
                  :hint/add.anything.by-nameplate
                  :hint/add.anything.group])}
  [props]
  (let [anything? (= "add-anything" (namespace (:handler props)))]
    [:div.pad-bottom-3
     [:div.margin-v-3.text-center
      (icons/get :add/nameplate-photo)]
     [widgets/black-button
      {:id "button-asset-by-nameplate"
       :href (routing/path-for
              ;; NOTE
              ;; not dynamically generating keys, to preserve
              ;; ability to globally find/refactor/rename these keywords
              [(if anything? :add-anything/asset-by-nameplate
                             :add/asset.nameplate)])
       :class "margin-h-3 flex"}
      (i/get :add/by-nameplate)]
     [:a.text-dark-gray.text-center.margin-top-2.margin-bottom-3.text-underline.text-size-14.block
      {:href (i/get :add/nameplate-help.link.href)
       :target "_blank"
       :rel "noopener"}
      (i/get :add/nameplate-help.link)]
     divider-or
     [:div.margin-v-3.text-center
      (icons/get :add/manual-entry)]
     [widgets/black-button
      {:id "button-asset-by-form"
       :href (routing/path-for [(if anything?
                                  :add-anything/asset-by-form
                                  :add/asset.form)])
       :class "margin-h-3 flex"}
      (i/get :i/type-manually)]]))

(v/defview anything
  {:header {:title (i/get :i/add-anything)}}
  [props]
  (let [header :div.text-dark-gray.text-size-13.text-uppercase.weight-medium.pad-h-3]
    [:div.flex.flex-column.pad-v-3
     [header (i/get :i/add-item)]
     [asset-start props]
     [divider-line]
     [header (i/get :i/add-files)]
     [collection-picker props]
     [divider-line {:style {:margin-top 0}}]
     [header (i/get :i/add-other)]
     [other-picker props]]))

(v/defview add-end-confirm
  {:header {:title utils/space}
   :component-did-mount
   (fn [this]
     (branch/track! "add-asset")
     (js/setTimeout #(forms/swap-state! dissoc ::forms/data) 200)
     (hints/show! [:hint/add.asset.end-confirm.view-item]))}
  []
  (let [payload (:add/end-confirm-props (forms/state))
        {:keys [name
                parent-name
                entity]} (if-let [asset (:asset payload)]
                           {:name (schema/asset-display-name asset)
                            :parent-name (:name (:assetGroup payload))
                            :entity asset}
                           (let [content (:content payload)]
                             {:name (:title content)
                              :parent-name (parent/parent-name (:contentedId payload))
                              :entity content}))
        image (or (:imageLink entity)
                  (:link (:primaryImage entity)))
        processing-time (-> (q-asset/system-status)
                            :systemStatus
                            :message
                            (or "24-48 Hrs."))]
    [:div.flex.flex-column.bg-off-white.justify-center.text-center.height-100p.pad-all-3
     [:div.flex-auto.items-center.flex.flex-column.justify-center
      [:div.text-size-17.weight-medium.margin-v-3
       (i/get :add/end.success)]
      [:div.text-size-26.weight-semi-bold.margin-v-3
       name]
      (when (utils/some-str parent-name)
        [:div.text-size-17.weight-medium.margin-v-3
         parent-name])
      (when image
        [:img.margin-v-3 {:src image
                          :style {:height 80}}])
      [:a.text-dark-gray.text-size-15.weight-medium.text-underline.margin-v-3
       {:id "link-end-confirm-view-item"
        :href (app-route/details-href entity)}
       (i/get :add/end.view-item)]
      (when (= (:alertStatus entity) "processing")
        (str "Processing (" processing-time ")"))]
     [:div.flex
      [:a.bg-black.pad-all-3.round-3.margin-all-2.text-white.flex-auto
       {:href (routing/path-for :router/form-modal
                                (:path (first (routing/breadcrumbs :router/form-modal))))}
       (i/get :i/add-another)]

      [:a.bg-black.pad-all-3.round-3.margin-all-2.text-white.flex-auto
       {:href (routing/path-for :router/form-modal nil)}
       (i/get :i/done)]]]))

(defn asset-create! [this data]
  (->> {:component this
        :on-complete
        (fn [x]
          (let [asset-data (-> x
                               (js->clj :keywordize-keys true)
                               :data
                               :asset_create)]
            (forms/swap-state! assoc :add/end-confirm-props asset-data)

            (realtime/poll-asset-status! (-> asset-data
                                             :asset
                                             :id))

            (db/dispatch [:routing/nav (app-route/add-end-href)])))}
       (q-asset/asset-create! data)))

(defn default-parent
  "Return the default parent-id appropriate to the type of content specified."
  [typename]
  (case typename
    "Asset"
    (or
     ;; 1. current group
     (db/get-in [:db/routers :router/root :route-params :group-id])
     ;; 2. any group named "Everything Else"
     (some->> (current-property/get-property)
              :assetGroups
              (filter #(= (:name %) "Everything Else"))
              (first)
              (:id)))
    "Content"
    (or
     ;; 1. current group
     (db/get-in [:db/routers :router/root :route-params :group-id])
     ;; 2. property ie
     (:id (property/get-current-property)))))

(defn valid-parent-type?
  "Returns true if `parent-type` can be a parent for `child-type`"
  [child-type parent-type]
  (some-> {"Asset" #{"AssetGroup"}
           "Content" #{"Asset"
                       "AssetGroup"
                       "Property"}}
          (get child-type)
          (contains? parent-type)))

(defn populate-initial-state! [parent-key child-type]
  (let [default (default-parent child-type)
        {:keys [root root-type mutable?] :as context} (parent/get-parent-context)
        valid-root? (valid-parent-type? child-type root-type)
        initial-parent (if valid-root? root nil)]
    (forms/swap-state! update ::forms/data
                       (fn [data]
                         (-> data
                             (update parent-key (fn [existing-value]
                                                  (or (if mutable?
                                                        (or existing-value initial-parent)
                                                        initial-parent)
                                                      default)))
                             (merge (-> (forms/state)
                                        :query-data
                                        :initial-form-data)))))))

(defn nameplate-field [state props]
  (list
    (fields/from-schema
    :Asset/nameplateLink
    (merge (forms/field-props state :Asset/nameplateLink)
           props))
    [:div.flex.margin-top-3
    {:key "nameplate-info"}
    [:div.width-33p.flex-none
     [:img.width-100p {:src "/images/nameplateExample.jpg"}]]
    [:div.pad-left-3.text-size-13.text-dark-gray.flex.flex-column
     (i/get :add/nameplate-locator.description)
     [:a.text-black.text-size-17.weight-semi-bold.margin-v-2.flex.justify-between.items-center.hover-opacity-parent
      {:href (app-route/nameplate-locator-href)
       :target "_blank"
       :rel "noopener"}
      (i/get :i/nameplate-locator)
      [:div.inline-block.hover-opacity-child shapes/chevron-right]]]]))

(v/defview asset-by-nameplate
  {:header {:title (i/get :i/add-item)}
   :component-will-mount (partial populate-initial-state! :Asset/assetGroupId "Asset")
   :component-did-mount utils/focus-first-input!}
  []
  (let [{:keys [state] :as this} (r/current-component)]
    [:div.pad-all-3.relative
     [:form {:on-submit (partial forms/form-submit {:component this
                                                    :submit! (partial asset-create! this)
                                                    :validators
                                                    (->> [:Asset/assetGroupId
                                                          :Asset/nameplateLink]
                                                         (reduce (fn [m k]
                                                                   (assoc m k [:required]))
                                                                 {}))})}

      (nameplate-field state {})

      (doall (for [key [:Asset/tagName
                        :Asset/nickname
                        :Asset/assetGroupId]]
               ^{:key key} [fields/from-schema key
                            (forms/field-props state key)
                            #_(cond-> (= key :Asset/tagName)
                                      (assoc :on-change* (fn [{:keys [value entity]}]
                                                           (when (utils/some-str value)
                                                             (println (str " ;; " value "\n" \" (:id entity) \"))))))]))

      [widgets/graphql-submit-button
       {:state (g/mutation-state)
        :label (i/get :i/create)}]]]))

(v/defview asset-by-manual-typing
  {:header {:title (i/get :i/add-item)}
   :component-did-mount utils/focus-first-input!
   :component-will-mount (partial populate-initial-state! :Asset/assetGroupId "Asset")}
  []
  (let [{:keys [state] :as this} (r/current-component)
        transcription-available? (some-> (get (forms/form-data)
                                              :Asset/tagName)
                                         (q-root/fetch-tag)
                                         :entity
                                         :transcriptionAvailable)
        required-keys (cond-> #{:Asset/assetGroupId}
                              ;; if transcription is available,
                              ;; require manufacturer+model
                              transcription-available? (into [:Asset/manufacturer
                                                              :Asset/modelNumber]))]
    [:form.pad-all-3.relative
     {:on-submit (partial forms/form-submit {:component this
                                             :submit! (partial asset-create! this)
                                             :validators
                                             (->> required-keys
                                                  (reduce (fn [m k]
                                                            (assoc m k [:required]))
                                                          {}))})}
     (doall (for [key [:Asset/imageLink
                       :Asset/tagName
                       :Asset/manufacturer
                       :Asset/modelNumber
                       :Asset/serialNumber
                       :Asset/nickname
                       :Asset/assetGroupId]]
              (fields/from-schema
               key
               (cond-> (forms/field-props state key)

                       (contains? required-keys key)
                       (update :validators conj :required)

                       (and (#{:Asset/manufacturer
                               :Asset/modelNumber} key)
                            (not (contains? required-keys key)))
                       (assoc :placeholder-right [:div.text-dark-gray (i/get :i/optional)])))))

     [widgets/graphql-submit-button
      {:state (g/mutation-state)
       :label (i/get :i/create)}]]))

(def asset-clarify-form-keys [:tagName
                              :manufacturer
                              :modelNumber
                              :nickname
                              :transcriptionComment
                              :serialNumber])

(v/defview asset-clarify
  {:header {:title (str (i/get :i/clarify)
                        " "
                        (i/get :i/asset))}
   :component-will-mount
   (fn [this]
     (when-let [asset (->> (:asset-id (:props this))
                           (hash-map :id)
                           (q-asset/asset)
                           :entity)]

       ;; set initial asset data into form-state
       (forms/swap-state! assoc ::forms/data
                          (->> (select-keys asset asset-clarify-form-keys)
                               (utils/map-keys (comp (partial keyword "Asset") name))))))}
  [{:keys [asset-id]}]
  (let [{:keys [state] :as this} (r/current-component)
        {{:keys [rejectionCode]} :entity} (q-asset/asset-contents {:id asset-id})
        rejectionMessage (some-> (get i/rejectionCode->key (str rejectionCode))
                                 (i/get))
        {{:keys [firstName]} :me} (q-root/me)
        must-have-some-value #(when (empty? (vals (forms/form-data)))
                                {:invalid (i/get :asset/asset-clarify.invalid.empty)})]
    [:div
     [:div.pad-all-3.margin-bottom-2
      {:style {:background (:alert-yellow constants/colors)}}
      (when (utils/some-str firstName)
        [:div.text-size-14.weight-semi-bold.text-uppercase (str "Hi " firstName ",")])
      [:div.margin-v-2 rejectionMessage]]
     [:form.pad-all-3
      {:on-submit (fn [e]
                    (.preventDefault e)
                    (if (must-have-some-value)
                      (swap! state assoc :dirty? true)
                      (forms/form-submit {:component this
                                          :submit! (fn [data]
                                                     (q-asset/asset-update!
                                                       (assoc data :id asset-id
                                                                  :requestTranscription true)
                                                       {:component this
                                                       :on-complete
                                                       (fn [] (routing/nav! (routing/path-for :router/form-modal nil)))}))
                                          :validators (reduce (fn [m k]
                                                                (assoc m k [:not-required!]))
                                                              {}
                                                              asset-clarify-form-keys)} e)))}
      (nameplate-field state {:validators [:not-required!]})
      (doall (for [key [:Asset/tagName
                        :Asset/manufacturer
                        :Asset/modelNumber
                        :Asset/serialNumber
                        :Asset/nickname
                        :Asset/transcriptionComment]]
               (fields/from-schema key
                                   (-> (forms/field-props state key)
                                       (update :validators conj :not-required!)))))
      (when-let [message (and (:dirty? @state)
                              (-> (validation/apply-validator must-have-some-value nil nil)
                                  :invalid
                                  :message))]
        [text/render-helptext {:text [:div.text-red message]
                               :persistent? true}])
      [widgets/graphql-submit-button {:state (g/mutation-state)
                                      :label (i/get :i/send)}]]]))


(v/defview content-add
  {:component-will-mount (partial populate-initial-state! :Content/contentedId "Content")
   :component-did-mount utils/focus-first-input!}
  [{:keys [collection]}]
  (let [{:keys [state] :as this} (r/current-component)
        note? (= "notes" collection)
        submit!
        (fn [e]
          (some-> e (.preventDefault))
          (let [{:keys [Content/link] :as data} (forms/form-data)
                data (-> data
                         (assoc :Content/curated false
                                :Content/category (case collection
                                                    ;; NOTE
                                                    ;; we cannot infer the category from the file extension,
                                                    ;; because document/receipt/image file extensions overlap.
                                                    "notes" "note"
                                                    "receipts" "receipt"
                                                    "documents" "document"
                                                    (schema/ext-category (utils/ext link)))))
                validations (schema/validate-paths (conj (keys data)
                                                         ;; always validate keys that are required,
                                                         ;; other keys can be inferred from the data map itself
                                                         :Content/contentedId
                                                         :Content/link) data)]
            (if (validation/invalid? validations)
              (swap! state assoc :dirty? true)
              (files/create-content! this data))))]
    [:div.flex.flex-column.pad-all-3.relative
     [:form
      {:on-submit submit!}
      (when-not note?
        [fields/from-schema :Content/link
         (merge (forms/field-props state :Content/link)
                {:data-allowed-file-extensions
                 (schema/file-collection-extensions collection)
                 :on-error
                 (fn [{:keys [filename]}]
                   (when (= filename (get (forms/form-data) :Content/title))
                     (forms/swap-state! assoc-in [::forms/data :Content/title] nil)
                     (swap! state dissoc :suggested-title)))
                 :on-select
                 (fn [{:keys [filename ext]}]
                   (swap! state assoc :suggested-title filename)
                   (forms/swap-state! assoc-in [::forms/data :Content/title] filename))})])
      [:div.margin-top-2
       (when-not note?
         [:div
          [fields/from-schema :Content/title
           (-> (forms/field-props state :Content/title)
               (assoc :suggested-value (:suggested-title @state)))]
          [fields/from-schema :Content/description
           (forms/field-props state :Content/description)]])
       (when note?
         [:div
          [fields/from-schema :Note/title
           (-> (forms/field-props state :Content/title)
               (assoc :suggested-value (:suggested-title @state)))]
          [fields/from-schema :Content/body
           (forms/field-props state :Content/link)]])
       [fields/from-schema :Content/contentedId
        (forms/field-props state :Content/contentedId)]]
      [widgets/graphql-submit-button
       {:state (g/mutation-state)
        :label (i/get (if note?
                        :i/create
                        :i/upload-file))}]]]))

(v/defview add-file-by-collection
  {:header (fn [{:keys [collection]}]
             {:title (i/get (if collection (keyword "i" (str "add-" collection))
                                           :files/add-unknown))})}
  [{:keys [collection] :as props}]
  [:div.flex.flex-column
   {:key "add-content"}
   (if (and collection (not= collection "unknown"))
     [content-add props]
     [collection-picker])])
